<script>
import ListingModel from "@/views/Training/Catalog/Components/ListingModel.vue";

export default {
    components: {ListingModel}

};
</script>

<template>
    <ListingModel root-path="training_request_catalogs"/>
</template>
